/* ThermoAspen Materials & Cladding — server client 1.0.0 (TA Commercial Phase 4, 3 Nov 2026).
 * © 2026 ThermoAspen Ireland. All rights reserved.
 *
 * The Materials & Cladding page (page.materials-and-cladding) no longer calculates anything. The bench and
 * cladding geometry, the Cladding Optimiser and the Materials Engine run on the ThermoAspen Designer server
 * (through the Shopify App Proxy at /apps/designer/materials). This file:
 *  - stands in for the Project Runtime's getConsumerSnapshot() and sceneFromProject() on this page, returning
 *    what the server worked out for the current design (the 3D preview and the wall elevations draw it);
 *  - stands in for ThermoAspenMaterialsEngine.calculate() (the Materials list);
 *  - gives the Cladding Optimiser block its results (ThermoAspenMaterialsServerClientV1.optimise()).
 * The calls are synchronous, so the first call for a new choice starts the server request and returns the last
 * result (or nothing on the first visit). When the reply arrives, ThermoAspenProjectRuntimeUpdated (new design),
 * ThermoAspenMaterialsServerUpdated and ThermoAspenMaterialsEngineReady are fired and the blocks redraw.
 * Login and server problems are shown in #ta-materials-server-notice.
 * No calculation rules live here. The shop catalogue (SKU -> variant, price, availability) is the one the page
 * already shows; it is sent with each request so the server can match the lines to shop products.
 */
(function(W,D){
'use strict';
var VERSION='1.0.0',ENDPOINT='/apps/designer/materials',TIMEOUT_MS=60000,DEBOUNCE_MS=150,KEEP_DESIGNS=3,KEEP_RESULTS=40,NOTICE_ID='ta-materials-server-notice';
if(W.ThermoAspenMaterialsServerClientV1&&W.ThermoAspenMaterialsServerClientV1.version===VERSION)return;

function clone(v){if(v==null)return v;try{return JSON.parse(JSON.stringify(v))}catch(e){return v}}
function obj(v){return!!v&&typeof v==='object'&&!Array.isArray(v)}
function num(v,f){v=Number(v);return isFinite(v)?v:f}
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
/* Same canonical JSON the server uses for its design fingerprint. */
function stable(v){if(v==null||typeof v!=='object')return JSON.stringify(v);if(Array.isArray(v))return'['+v.map(stable).join(',')+']';return'{'+Object.keys(v).sort().filter(function(k){return v[k]!==undefined}).map(function(k){return JSON.stringify(k)+':'+stable(v[k])}).join(',')+'}'}
function dispatch(name,detail){try{W.dispatchEvent(new CustomEvent(name,{detail:detail}))}catch(e){}}

/* ---------- the design ---------- */
/* Accepts what the page passes: a consumer snapshot, a ThermoAspenProject record, {design} or a bare design. */
function designOf(v){
  if(!obj(v))return null;
  if(v.format==='ThermoAspenProjectRuntimeConsumer'&&obj(v.project))return v.project;
  if(obj(v.schema)&&v.schema.name==='ThermoAspenProject'&&obj(v.design)&&obj(v.design.room))return v.design;
  if(obj(v.design)&&obj(v.design.room))return v.design;
  return obj(v.room)?v:null;
}
/* The camera position and viewer version don't change anything here (same rule as the server). */
function keyOf(design){var d=clone(design);if(obj(d.exterior)){delete d.exterior.camera;delete d.exterior.viewerVersion}return stable(d)}

var designs=Object.create(null),designOrder=[],aliases=Object.create(null);
function remember(dk,design){if(!designs[dk])designs[dk]={design:clone(design),snapshot:null,scene:null,state:'new',error:null,results:Object.create(null),resultOrder:[],lastOpt:null,lastMat:null,want:null,inflight:false,timer:0};designOrder=designOrder.filter(function(k){return k!==dk});designOrder.unshift(dk);while(designOrder.length>KEEP_DESIGNS){var old=designOrder.pop();delete designs[old];Object.keys(aliases).forEach(function(a){if(aliases[a]===old)delete aliases[a]})}return designs[dk]}
function resolve(v){var design=designOf(v);if(!design)return null;var k=keyOf(design),dk=aliases[k]||k;return{dk:dk,entry:designs[dk]||remember(dk,design)}}
function currentDesign(){var rt=W.ThermoAspenProjectRuntime;try{return rt&&rt.__taReadCurrentProject?rt.__taReadCurrentProject():null}catch(e){return null}}

/* ---------- choices ---------- */
var current={overrides:{zoneGradeOverrides:{},stockLengthOverrides:{}},prefs:null};
function cleanOverrides(o){var g={},s={};o=o||{};Object.keys(o.zoneGradeOverrides||{}).forEach(function(k){var v=o.zoneGradeOverrides[k];if(v==='A'||v==='B')g[k]=v});Object.keys(o.stockLengthOverrides||{}).forEach(function(k){var v=Math.round(num(o.stockLengthOverrides[k],0));if(v>0)s[k]=v});return{zoneGradeOverrides:g,stockLengthOverrides:s}}
/* Same rounding as the Materials Engine. */
function cleanPrefs(p){p=p||{};var b=Math.round(Math.max(0,Math.min(100,num(p.bSharePct==null?100:p.bSharePct,100)))/5)*5,w=Math.round(Math.max(0,Math.min(15,num(p.wastePct==null?10:p.wastePct,10))));return{gradeMode:p.gradeMode==='recommended'?'recommended':'custom',bSharePct:b,wastePct:w,benchSupply:p.benchSupply==='prefabricated'?'prefabricated':'materials'}}
/* The Materials list's saved choices, so the first request can bring the Materials list too. */
function prefsFromPage(){var a=W.__ThermoAspenMaterialsV2,p=null;try{p=a&&typeof a.getPreferences==='function'?a.getPreferences():null}catch(e){p=null}if(!p)return null;var mix=p.timberGradeMix||{};return cleanPrefs({gradeMode:p.claddingGradeMode,bSharePct:mix.g2SharePct,wastePct:p.claddingWastePct,benchSupply:p.benchSupply})}
function optKey(ov){return'o:'+stable(ov)}
function matKey(pr,ov){return'm:'+stable(pr)+(pr.gradeMode==='recommended'?'|'+stable(ov):'')}
function keep(e,key,reply){if(!e.results[key])e.resultOrder.push(key);e.results[key]=reply;while(e.resultOrder.length>KEEP_RESULTS)delete e.results[e.resultOrder.shift()]}

/* ---------- shop catalogue (already on the page) ---------- */
var CATALOGUE=null;
function catalogue(){if(CATALOGUE)return CATALOGUE;var el=D.getElementById('ti-materials-engine-catalogue'),c={};if(!el)return{};try{c=JSON.parse(el.textContent||'{}')||{}}catch(e){c={}}CATALOGUE=c;return c}

/* ---------- notice (working / log in / error) ---------- */
function noticeEl(){var n=D.getElementById(NOTICE_ID);if(n)return n;var host=D.getElementById('ti-materials-3d-preview')||D.getElementById('ti-materials-list')||D.getElementById('ti-cladding-optimiser');if(!host||!host.parentNode)return null;n=D.createElement('div');n.id=NOTICE_ID;n.hidden=true;host.parentNode.insertBefore(n,host);return n}
function showNotice(kind,html){var n=noticeEl();if(!n)return;if(!kind){n.hidden=true;n.innerHTML='';n.className='';return}n.className='tams-notice tams-notice--'+kind;n.innerHTML=html;n.hidden=false;var b=n.querySelector('[data-tams-retry]');if(b)b.addEventListener('click',retry)}
function loginHtml(){var back=W.location.pathname+W.location.search;return'<strong>Log in to see the cladding cutting list and materials</strong><span>They are worked out for your ThermoAspen account. <a href="/account/login?return_url='+encodeURIComponent(back)+'">Log in</a></span>'}
function refreshNotice(){
  var top=designs[designOrder[0]];
  if(!top||top.state==='ready')return showNotice(null);
  if(top.state==='login')return showNotice('login',loginHtml());
  if(top.state==='error')return showNotice('error','<strong>The cladding cutting list and materials could not be loaded.</strong><span>'+esc(top.error||'')+' <button type="button" data-tams-retry>Try again</button></span>');
  if(!top.snapshot)return showNotice('working','<strong>Working out the cladding and materials…</strong><span>This usually takes a few seconds.</span>');
  showNotice(null);
}

/* ---------- server requests (one at a time per design; the latest choice wins) ---------- */
function want(dk,e,part){
  var w=e.want||(e.want={});
  if(part.overrides)w.overrides=part.overrides;
  if(part.prefs)w.prefs=part.prefs;
  if(e.state==='login'||e.state==='error')return; // wait for Try again / log in
  if(e.timer)clearTimeout(e.timer);
  e.timer=setTimeout(function(){e.timer=0;send(dk,e)},DEBOUNCE_MS);
}
function satisfied(e,w){
  var ov=w.overrides||current.overrides,need=!e.snapshot;
  if(w.overrides&&!e.results[optKey(ov)])need=true;
  if(w.prefs&&!e.results[matKey(w.prefs,w.prefs.gradeMode==='recommended'?ov:null)])need=true;
  return!need;
}
function send(dk,e){
  if(e.inflight||!e.want)return;
  var w=e.want;e.want=null;
  if(satisfied(e,w))return;
  var ov=w.overrides||current.overrides,pr=w.prefs||current.prefs||prefsFromPage(),wantSnapshot=!e.snapshot;
  var ctl=typeof AbortController==='function'?new AbortController():null,timer=ctl?setTimeout(function(){ctl.abort()},TIMEOUT_MS):0,t0=Date.now();
  e.inflight=true;if(e.state!=='ready')e.state='pending';refreshNotice();
  fetch(ENDPOINT,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({design:e.design,overrides:ov,prefs:pr,wantSnapshot:wantSnapshot,catalogue:catalogue()}),signal:ctl?ctl.signal:undefined})
    .then(function(r){return r.text().then(function(t){var j=null;try{j=JSON.parse(t)}catch(x){}return{r:r,j:j}})})
    .then(function(x){
      if(timer)clearTimeout(timer);
      var j=x.j,newSnapshot=false;
      if(!x.r.ok||!j||j.ok!==true){
        var login=!!(j&&j.loginRequired);
        e.state=login?'login':'error';e.error=login?'':(j&&j.error?String(j.error):'The server replied '+x.r.status+'.');return;
      }
      if(j.valid===false){e.state='error';e.error=j.reason||'The design could not be worked out.';return}
      if(wantSnapshot){
        if(!j.snapshot||!j.recommendation){e.state='error';e.error='The server reply was incomplete.';return}
        e.snapshot=j.snapshot;e.scene=j.scene||null;newSnapshot=true;
        if(j.snapshot.project)aliases[keyOf(j.snapshot.project)]=dk;
      }
      var reply={designFingerprint:j.designFingerprint,recommendation:j.recommendation,zones:j.zones,materials:j.materials,overrides:ov,prefs:pr};
      /* The server drops choices that no longer apply (a zone that no longer exists, a grade equal to the default,
         a stock length that can't supply the cuts). File the reply under both the asked and the cleaned choices. */
      var rec=j.recommendation||{},pov=cleanOverrides({zoneGradeOverrides:rec.zoneGradeOverrides,stockLengthOverrides:rec.stockLengthOverrides});
      reply.cleanOverrides=pov;
      [ov,pov].forEach(function(o){keep(e,optKey(o),reply);if(pr&&j.materials)keep(e,matKey(pr,pr.gradeMode==='recommended'?o:null),reply)});
      e.lastOpt=reply;if(pr&&j.materials)e.lastMat=reply;
      e.state='ready';e.error=null;
      last={designFingerprint:j.designFingerprint||null,engineBundle:j.engineBundle||null,stackId:j.stackId||null,cached:!!j.cached,timingMs:j.timingMs||null,roundTripMs:Date.now()-t0,receivedAt:new Date().toISOString()};
      if(newSnapshot)dispatch('ThermoAspenProjectRuntimeUpdated',{source:'designer-server',version:'server-'+VERSION,project:clone(e.snapshot.project),data:clone(e.snapshot)});
      dispatch('ThermoAspenMaterialsServerUpdated',{designFingerprint:j.designFingerprint});
      dispatch('ThermoAspenMaterialsEngineReady',{version:'server-'+VERSION,source:'designer-server'});
    },function(err){
      if(timer)clearTimeout(timer);
      e.state='error';e.error=err&&err.name==='AbortError'?'The server took too long to reply.':'The server could not be reached.';
    })
    .then(function(){
      e.inflight=false;refreshNotice();
      if(e.state==='login'||e.state==='error'){dispatch('ThermoAspenMaterialsServerUpdated',{error:e.state});return}
      if(e.want)send(dk,e); // a newer choice arrived while this one was on its way
    });
}
var last=null;
function retry(){Object.keys(designs).forEach(function(k){var e=designs[k];if(e.state==='login'||e.state==='error'){e.state=e.snapshot?'ready':'new';e.error=null;want(k,e,{overrides:current.overrides,prefs:current.prefs})}});refreshNotice()}

/* ---------- what the page asks for ---------- */
function snapshotFor(v){
  var r=resolve(v||currentDesign());if(!r)return null;
  if(r.entry.snapshot)return clone(r.entry.snapshot);
  if(!r.entry.inflight&&r.entry.state!=='login'&&r.entry.state!=='error')want(r.dk,r.entry,{overrides:current.overrides,prefs:current.prefs});
  refreshNotice();
  return null;
}
/* The optimiser result for these zone grade / stock length choices.
   Returns {reply, pending, state}: reply is the exact result, or the latest one for this design while the new one is on its way. */
function optimise(v,overrides){
  var r=resolve(v||currentDesign());if(!r)return{reply:null,pending:false,state:'none'};
  var ov=cleanOverrides(overrides);current.overrides=ov;
  var hit=r.entry.results[optKey(ov)];
  if(hit)return{reply:clone(hit),pending:false,state:r.entry.state};
  want(r.dk,r.entry,{overrides:ov});
  return{reply:r.entry.lastOpt?clone(r.entry.lastOpt):null,pending:true,state:r.entry.state};
}
function materialsFor(v,prefs){
  var r=resolve(v||currentDesign());if(!r)return{reply:null,pending:false,state:'none'};
  var pr=cleanPrefs(prefs);current.prefs=pr;
  var hit=r.entry.results[matKey(pr,pr.gradeMode==='recommended'?current.overrides:null)];
  if(hit&&hit.materials)return{reply:clone(hit),pending:false,state:r.entry.state};
  want(r.dk,r.entry,{prefs:pr,overrides:current.overrides});
  return{reply:r.entry.lastMat?clone(r.entry.lastMat):null,pending:true,state:r.entry.state};
}

/* ---------- stand-in for the Project Runtime's engine-backed calls on this page ---------- */
function wrapRuntime(){
  var rt=W.ThermoAspenProjectRuntime;if(!rt||rt.__taMaterialsServer)return!!rt;
  var read=rt.readCurrentProject,scene=rt.sceneFromProject;
  rt.__taReadCurrentProject=function(){return typeof read==='function'?read():null};
  rt.getConsumerSnapshot=function(v){return snapshotFor(designOf(v)||currentDesign())};
  rt.sceneFromProject=function(v){var r=resolve(designOf(v)||currentDesign());if(r&&r.entry.scene)return clone(r.entry.scene);try{return typeof scene==='function'?scene(v):null}catch(e){return null}};
  rt.isReady=function(){return true};
  rt.__taMaterialsServer=VERSION;
  return true;
}
if(!wrapRuntime())W.addEventListener('ThermoAspenProjectRuntimeReady',wrapRuntime);

/* ---------- stand-in for the Materials Engine ---------- */
var MONEY={currency:'EUR',unit:'minor',scale:100},STOCK_LENGTHS={A:[1800,2100,2400,2700],B:[2100,2400,2700]};
function emptyResult(d,pr,reason){return{valid:!reason,waiting:!reason,money:clone(MONEY),lines:[],sections:{timber:[],benches:[],install:[]},totals:{exVat:0,incVat:0},benchWarning:'',preferences:pr||null,sourceRevision:d&&d.revision!=null?d.revision:null,reason:reason||undefined}}
W.ThermoAspenMaterialsEngine={
  version:'server-'+VERSION,source:'designer-server',money:clone(MONEY),
  calculate:function(d,prefs){
    if(!d||!d.dimensions||!d.cladding)return emptyResult(d,null,'DESIGNER_DATA_MISSING');
    var x=materialsFor(d,prefs),r=x.reply&&x.reply.materials;
    if(!r)return emptyResult(d,cleanPrefs(prefs));
    r.pending=!!x.pending;return r;
  },
  getMoneyContract:function(){return clone(MONEY)},
  getCatalogue:function(){return clone(catalogue())},
  getStockLengths:function(){return clone(STOCK_LENGTHS)}
};

W.ThermoAspenMaterialsServerClientV1={
  version:VERSION,endpoint:ENDPOINT,retry:retry,optimise:optimise,
  isPending:function(){return designOrder.some(function(k){var e=designs[k];return e&&(e.inflight||!!e.want||!!e.timer)})},
  status:function(){return{designs:designOrder.map(function(k){var e=designs[k];return{state:e.state,error:e.error,hasSnapshot:!!e.snapshot,results:e.resultOrder.length}}),last:clone(last)}}
};
dispatch('ThermoAspenMaterialsEngineReady',{version:'server-'+VERSION,source:'designer-server'});
})(window,document);
